import { registerPlugin } from '@capacitor/core';

export const NativeAudio = registerPlugin('NativeAudio');